module.exports = __webpack_public_path__ + "static/media/2.5a4e3fce.webp";